import useSeo from './UseSeo';

export const useSeoHomePage = () => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  useSeo({
    title: 'Trang chủ | Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ',
    description:
      'Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ là nơi kết nối, chia sẻ và lan toả giá trị giữa các thế hệ sinh viên K21.',
    keywords:
      'cựu sinh viên, K21, kinh tế, Đại học Cần Thơ, Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ, kết nối, giao lưu, đồng môn',
    ogTitle: 'Trang chủ | Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ',
    ogDescription:
      'Trang thông tin chính thức của Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ. Cập nhật hoạt động, hình ảnh và sự kiện.',
    ogUrl: url,
  });
};

export const useSeoEmptyPost = () => {
  useSeo({
    title: 'Bài viết | Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ',
  });
};

export const useSeoContact = () => {
  useSeo({
    title: 'Liên hệ | Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ',
    description:
      'Liên hệ với Ban điều hành Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ để được hỗ trợ thông tin, kết nối và hợp tác.',
    keywords: 'liên hệ, cựu sinh viên, K21, kinh tế CTU, kết nối đồng môn',
    ogTitle: 'Liên hệ | Hội cựu sinh viên Kinh tế K21',
    ogDescription:
      'Hãy liên hệ với chúng tôi để cập nhật tin tức, tham gia sự kiện và đồng hành cùng cộng đồng K21 – Đại học Cần Thơ.',
    ogUrl: 'https://alumni-k21.ctu.edu.vn/lien-he',
  });
};

export const useSeoPostDetail = (post) => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  useSeo({
    title: post?.title
      ? `${post.title} | Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ`
      : 'Bài viết | Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ',
    description:
      post?.meta_description ||
      'Bài viết từ cộng đồng K21, chia sẻ hoạt động, cảm nghĩ, sự kiện đáng nhớ.',
    keywords:
      post?.meta_keywords ||
      'K21, kinh tế, cựu sinh viên, bài viết, chia sẻ, sự kiện',
    ogTitle: post?.meta_title || 'Bài viết | Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ',
    ogDescription:
      post?.meta_description ||
      'Khám phá những câu chuyện và chia sẻ đáng nhớ từ cộng đồng K21.',
    ogImage: post?.thumbnail || '/favicon.ico',
    ogUrl: url,
  });
};

export const useSeoPostList = (topic) => {
  const topicName = topic?.name || 'Bài viết';
  const description = `Danh sách các bài viết về chủ đề ${topicName} từ cộng đồng Hội cựu sinh viên Kinh tế K21 – Đại học Cần Thơ.`;
  const keywords = `${topicName}, K21, kinh tế CTU, cựu sinh viên, bài viết, chia sẻ`;
  const ogDescription = `Khám phá các bài viết trong chủ đề ${topicName} từ cộng đồng K21 – Kinh tế CTU.`;
  const url = typeof window !== 'undefined' ? window.location.href : '';

  useSeo({
    title: `${topicName} | Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ`,
    description,
    keywords,
    ogTitle: `${topicName} | Hội cựu sinh viên Kinh tế K21 - Đại học Cần Thơ`,
    ogDescription,
    ogUrl: url,
  });
};
